//
// Module for Security Administration External Login Request Detail
//
rs.module("content/security/administration/externalloginrequestdetail",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, responseOptions) {

            var form = $.js(jsSelectors.form);
            var responseRadioContainer = form.js(jsSelectors.responseRadioContainer);
            var rejectReasonInput = form.js(jsSelectors.rejectReasonInput);

            // Setup listener(s) on inputs to perform actions
            responseRadioContainer.find("input").on("click", () => responseChanged());

            // Handle the response changed event
            function responseChanged() {
                var response = responseRadioContainer.find("input:checked").val();
                rejectReasonInput.setDisabled(response == responseOptions.approve);
                rejectReasonInput.val("");
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);